import actionTypes from './actions/actionTypes'

const {
  REQUEST_USERDATA,
  RECEIVE_USERDATA,
  REQUEST_TOKENVALIDITY,
  RECEIVE_TOKENVALIDITY,
  USER_VALIDITY,
  SERVER_ERROR_OCURED,
  LOG_OUT,
  SHOULD_REDIRECT,
  SHOULD_REDIRECT_LOGIN,
  SEMINAR_UPGRADE_MODAL,
  RECEIVE_LOGIN_STATUS
} = actionTypes

const loginLayoutReducer = (
  state = {
    isCheckingUser: false,
    isCheckingToken: false,
    user: {},
    open: false,
    profile: {
      userid: null,
      name: null,
      role: null,
      email: null,
      accountType: null,
      stripeAccount: null,
      userLanguauge: 'jp',
      timezone: null
    },
    hasErrored: false,
    userExists: false,
    logoutSuccess: false,
    shouldRedirect: false,
    redirectToLogin: false,
    tokenVerified: false
  },
  action
) => {
  switch (action.type) {
    case REQUEST_USERDATA:
      return Object.assign({}, state, {
        tokenVerified: false,
        isCheckingUser: true,
        hasErrored: false
      })
    case RECEIVE_USERDATA:
      return Object.assign({}, state, {
        tokenVerified: true,
        isCheckingUser: false,
        user: action.user,
        profile: {
          userid: action.user.id,
          name: action.user.name,
          role:
            action.user.plan === 'free_guest' || action.user.plan === 'free' || action.user.plan === 'guest'
              ? 'Guest'
              : 'Adminstrator',
          email: action.user.email,
          accountType: action.user.plan,
          stripeAccount: action.user.stripe_account,
          userLanguauge:
            action.user.language && action.user.language === 'jp' ? 'ja' : 'en',
          timezone: action.user.timezone
        },
        hasErrored: false
      })
    case REQUEST_TOKENVALIDITY:
      return Object.assign({}, state, {
        isCheckingToken: true
      })
    case RECEIVE_TOKENVALIDITY:
      return Object.assign({}, state, {
        isCheckingToken: false
      })
    case USER_VALIDITY:
      return Object.assign({}, state, {
        userExists: action.userExists,
        hasErrored: false
      })
    case SEMINAR_UPGRADE_MODAL:
      return Object.assign({}, state, {
        open: action.open
      })
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasErrored: true
      })
    case LOG_OUT:
      return Object.assign({}, state, {
        tokenVerified: false,
        logoutSuccess: action.logoutSuccess,
        hasErrored: false
      })
    case SHOULD_REDIRECT:
      return Object.assign({}, state, {
        shouldRedirect: action.shouldRedirect,
        hasErrored: false
      })
    case SHOULD_REDIRECT_LOGIN:
      return Object.assign({}, state, {
        redirectToLogin: action.redirectToLogin,
        hasErrored: false
      })
      case RECEIVE_LOGIN_STATUS:
        return Object.assign({}, state, {
          logoutSuccess: false
        })
    default:
      return state
  }
}

export default loginLayoutReducer



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/reducer.js